import React from 'react';
import { FaWhatsapp, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-sitemap">
        <h3>Mapa do Site</h3>
        <ul>
          <li><a href="#hero">Início</a></li>
          <li><a href="#chalets">Chalés</a></li>
          <li><a href="#amenities">Comodidades</a></li>
          <li><a href="#location">Localização</a></li>
          <li><a href="#contact">Contato</a></li>
        </ul>
      </div>

      <div className="footer-contacts">
        <a href="https://wa.me/5512988505805" target="_blank" rel="noopener noreferrer" className="footer-contact-item">
            <FaWhatsapp /> (12) 98850-5805
        </a>
        <a href="mailto:contato@cabanasdevidro.com.br" className="footer-contact-item">
            <FaEnvelope /> contato@cabanasdevidro.com.br
        </a>
      </div>
      
      <div className="footer-bottom">
        <p className="copyright">Cabanas de Vidro © {new Date().getFullYear()} - Todos os direitos reservados.</p>
        <p className="developer">
          Desenvolvido por <a href="https://www.rootsales.com.br" target="_blank" rel="noopener noreferrer">rootSales</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
